__turbopack_context__.v({
  "multiColumn": "ReviewsList-module-scss-module__sK9tBa__multiColumn",
  "reviewColumn": "ReviewsList-module-scss-module__sK9tBa__reviewColumn",
  "reviewsList": "ReviewsList-module-scss-module__sK9tBa__reviewsList",
  "singleColumn": "ReviewsList-module-scss-module__sK9tBa__singleColumn",
});
